<template>
  <div class="entity-titles">
    <EHeading
      as="h2"
      class="entity-titles__title"
      :title="title"
      data-test-id="title"
    >
      {{ title }}
    </EHeading>
    <EHeading
      v-if="subtitle"
      as="h3"
      styled-as="h6"
      class="entity-titles__subtitle"
      :title="subtitle"
      data-test-id="subtitle"
    >
      {{ subtitle }}
    </EHeading>
  </div>
</template>

<script>
import EHeading from '~~/common/vue/components/heading';

export default {
  components: {
    EHeading,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.entity-titles__title,
.entity-titles__subtitle {
  @include line-clamp(2);

  font-weight: $font-weight-m;
  word-wrap: break-word;
  hyphens: auto;
}

.entity-titles {
  flex-grow: 1;
  min-width: 0;
}

// TODO: check if this style should be integrated in the Heading component
.entity-titles__subtitle {
  color: var(--color-text-secondary);
  font-size: $font-m;
  margin: $space-2s 0 $space-1s;

  @include line-clamp(2);
}
</style>
